import { toast } from 'react-toastify'
import apis from '../../../modules/apis'
import { axiosPost } from '../../../modules/axiosHelper'
import { s_portal_home } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

export const useOnclickHeartPacket = (props) => {
  const { isList, isMyContents, packetItems, setPacketItems, onAdded, onDeleted } = props
  const { t } = useTranslation()

  return async (e, packet) => {
    e.preventDefault()
    e.stopPropagation()

    const res = await axiosPost(apis.likeMaterial(), {
      course_id: packet.id,
      material_id: packet.id,
    })
    if (res.success) {
      if (res.my_course.is_selected) {
        if (onAdded) {
          onAdded()
        } else {
          toast(t(s_portal_home.material_like_added))
        }
      } else {
        if (onDeleted) {
          onDeleted()
        } else {
          toast(t(s_portal_home.material_like_deleted))
        }
      }
    } else {
      console.error(res)
    }

    if (isList) {
      const updatedPackets = packetItems.map((item) => {
        if (item.id === packet.id) {
          return { ...item, is_mine: !item.is_mine, is_my_course: !item.is_my_course }
        }
        return item
      })

      setPacketItems(isMyContents ? updatedPackets.filter((item) => item.is_mine || item.is_my_course) : updatedPackets)
    }
  }
}
